import Vue from 'vue';
export default {
  methods: {
    transformNotificationsList: function (notificationsList) {
      const transformedNotitfication = [...notificationsList].map(
        ({ creationDate, expirationDate, id, isActive, text, user }) => {
          const fullName =
            `${user.firstName} ${user.lastName}`.length > 2
              ? `${user.firstName} ${user.lastName}`
              : user.userName;
          return {
            creationDate: Vue.moment(creationDate).format('HH:mm:ss jYYYY/jMM/jDD'),
            expirationDate: Vue.moment(expirationDate).format('HH:mm:ss jYYYY/jMM/jDD'),
            status: isActive,
            description: text,
            id: id,
            user: fullName,
          };
        },
      );
      return transformedNotitfication;
    },
    transformNotification: function (notification) {
      return {
        status: notification?.isActive,
        creationDate: Vue.moment(notification.creationDate).format('HH:mm:ss jYYYY/jMM/jDD'),
        expirationDate: Vue.moment(notification.expirationDate).format('HH:mm:ss jYYYY/jMM/jDD'),
        isoExpirationDate: notification.expirationDate,
        description: notification.text,
        noticePhones: notification.noticePhones.map(({ phone }) => {
          return phone;
        }),
      };
    },
  },
};
